import {LoadingButton} from '@mui/lab';
import {Button} from '@mui/material';
import {FC, Fragment} from 'react';
import {useDeleteFiltersSets, useFiltersSetsRefresh} from '../../../../global/services/filters-sets';
import {
  contractTableDeleteFilterModalClose,
  useContractTableDeleteFilterModalStore,
} from '../../stores/contract-table-filters-delete-modal.store';
import {ContractModal} from '../contract-modal';

export const ContractsTableDeleteFiltersModal: FC = () => {
  const deletableId = useContractTableDeleteFilterModalStore((s) => s.deletableId);
  const {mutate, loading} = useDeleteFiltersSets();
  const refreshFiltersSets = useFiltersSetsRefresh();

  const afterMutateCallback = () => {
    refreshFiltersSets();
    contractTableDeleteFilterModalClose();
  };

  const handleDeleteFilter = async () => {
    if (!deletableId) return;
    await mutate([[deletableId]], afterMutateCallback);
  };

  return (
    <ContractModal
      title="Подтвердите удаление фильтра"
      open={!!deletableId}
      footer={
        <Fragment>
          <Button variant="outlined" color="error" onClick={contractTableDeleteFilterModalClose}>
            Отменить
          </Button>
          <LoadingButton variant="contained" onClick={handleDeleteFilter} loading={loading}>
            Удалить
          </LoadingButton>
        </Fragment>
      }
    />
  );
};
